import type { GenStatus, ProjectStatus } from "@/lib/api";
import type { StatusTone } from "@/components/primitives/StatusPill";
import { tr } from "@/i18n";

export function genStatusMeta(s: GenStatus): {
  tone: StatusTone;
  label: string;
  pulse?: boolean;
} {
  switch (s) {
    case "READY":
      return { tone: "success", label: tr("status.ready") };
    case "GENERATING":
      return { tone: "cyan", label: tr("status.generating"), pulse: true };
    case "FAILED":
      return { tone: "danger", label: tr("status.failed") };
    default:
      return { tone: "cyan", label: tr("status.pending") };
  }
}

export function projectStatusMeta(s: ProjectStatus): {
  tone: StatusTone;
  label: string;
} {
  switch (s) {
    case "COMPLETED":
      return { tone: "success", label: tr("status.completed") };
    case "IN_PROGRESS":
      return { tone: "cyan", label: tr("status.inProgress") };
    default:
      return { tone: "cyan", label: tr("status.draft") };
  }
}
